module.exports = __webpack_public_path__ + "img/tocop.5adf45f1.png";